import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.8 15.086 14.486 20.4m0 0-5.314-5.314m5.314 5.314V7.6a4 4 0 0 0-4-4H4.2"
    />
  </svg>
);
export default SvgArrowDownRight;
